<template>
  <!-- Sidebar -->
  <nav id="sidebar">
    <!-- Sidebar Scroll Container -->
    <div id="sidebar-scroll">
      <!-- Sidebar Content -->
      <div class="sidebar-content">
        <!-- Side Header -->
        <div class="content-header content-header-fullrow px-15">
          <div class="content-header-section text-center align-parent">
            <!-- Close Sidebar, Visible only on mobile screens -->
            <button type="button" class="btn btn-circle btn-dual-secondary d-lg-none align-v-r" @click="closeSidebar">
              <i class="fa fa-times text-danger"></i>
            </button>
            <!-- END Close Sidebar -->

            <!-- Logo -->
            <div class="content-header-item">
              <a class="link-effect font-w700" href="#">
                <i class="si si-check text-primary"></i>
                <span class="font-size-xl text-dual-primary-dark">VM</span><span class="font-size-xl text-primary">Control</span>
              </a>
            </div>
            <!-- END Logo -->
          </div>
        </div>
        <!-- END Side Header -->

        <!-- Side User -->
        <div class="content-side content-side-full content-side-user px-10 align-parent">
          <div class="text-center">
            <a class="img-link" href="#">
              <img class="img-avatar" :src="user.avatar_url" alt="">
            </a>
            <ul class="list-inline mt-10">
              <li class="list-inline-item">
                <a class="link-effect text-dual-primary-dark font-size-xs font-w600 text-uppercase" href="#">{{user.username}}</a>
              </li>
              <li class="list-inline-item">
                <a class="link-effect text-dual-primary-dark" href="#" @click.prevent="logout">
                  <i class="si si-logout"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- END Side User -->

        <!-- Side Navigation -->
        <admin-sidebar v-if="user.role === 'admin'"></admin-sidebar>
        <order-picker-sidebar v-if="user.role === 'orderpicker'"></order-picker-sidebar>

        <!-- END Side Navigation -->
      </div>
      <!-- Sidebar Content -->
    </div>
    <!-- END Sidebar Scroll Container -->
  </nav>
  <!-- END Sidebar -->
</template>

<script>
import AdminSidebar from './AdminSidebar.vue'
import OrderPickerSidebar from './OrderPickerSidebar.vue'

export default {
  components: {AdminSidebar, OrderPickerSidebar},
  data () {
    return {
      user: this.$auth.getUser()
    }
  },
  methods: {
    logout () {
      this.$auth.logout()
      this.$router.push({ name: 'login' })
    },
    closeSidebar () {
      this.$emit('close-sidebar')
    }
  }
}
</script>

<style scoped>
#page-container.side-scroll #side-overlay, #page-container.side-scroll #sidebar {
  overflow-y: auto !important;
}
</style>


// WEBPACK FOOTER //
// Sidebar.vue?4135035e